import { apiClient } from './apiClient'

export interface getSummaryDetails {
  startDate: string;
  endDate: string;
  accountId: string;
  period?: string;
}

export const dashboardService = {
  getDashboardSummary: (params?: getSummaryDetails): Promise<any> =>
    apiClient.get('/analytics/dashboard-summary', { params }).then(res => res.data),
  getSpendByTemplate: (params?: getSummaryDetails): Promise<any> =>
    apiClient.get('/analytics/spend-by-template', { params }).then(res => res.data),
}